module.exports = "/_next/static/images/Hero-ac76e7a09dde3017fe97a57afe82d66b.webp";